import { render } from "./skillList.vue?vue&type=template&id=71ae18d0"
import script from "./skillList.vue?vue&type=script&lang=js"
export * from "./skillList.vue?vue&type=script&lang=js"

import "./skillList.vue?vue&type=style&index=0&id=71ae18d0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__